export const NAMESPACE = "AllReplaysList";

export const PAGE_OPTIONS = [15, 45, 75];
